import React, { useState } from 'react';
import { Button, Image as Img } from 'antd';
import { LocaleString } from '@nackle/intl-tools';
import { Eye, CloseLarge } from '@nackle/origami-icons';
import { getString } from '@nackle/intl-tools';
import classNames from 'classnames';
const Transparent = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMSIgaGVpZ2h0PSIxIiB2aWV3Qm94PSIwIDAgMSAxIiBmaWxsPSJub25lIiBmaWxsT3BhY2l0eT0iMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDRaIiBmaWxsPSJub25lIiBmaWxsT3BhY2l0eT0iMCIvPgo8L3N2Zz4K';

/**
 * @ignore
 * @module MaskComponent
 * @description Renders a preview overlay with an eye icon and localized text
 * @returns {JSX.Element} A div containing the preview icon and text
 */
const MaskComponent = () => {
    return (
        <div className='preview-image'>
            <Eye />
            <span><LocaleString code="origami.image.preview" /></span>
        </div>
    );
};

/**
 * @ignore
 *
 * {@link https://ant.design/components/image#api}
 * @module ImageRender
 * @description Renders a preview image with a close button
 * @param {Object} props - Component props
 * @param {string} src - Source URL of the image to preview
 * @param {Function} handleCancel - Handler function for closing the preview
 * @returns {JSX.Element} A div containing the preview image and close button
 */
const ImageRender = ( { src, handleCancel } ) => (
    <div className='image-preview'>
        <img src={ src } alt='Preview' />
        <Button onClick={ handleCancel }><CloseLarge width={ 20 } height={ 20 } /></Button>
    </div>
);
/**
 * @module Image
 * @description A customizable image component with preview functionality and rounded corners support
 *
 * {@link https://ant.design/components/image#api Ant Design Image}
 * @param {Object} props - The component props
 * @param {string} className - Additional CSS class names
 * @param {string} src - The source URL of the image
 * @param {('small'|'medium'|'large'|string)} rounded - Rounded corner size. Can be preset values or custom size in px
 *
 * @returns {JSX.Element} A div containing the image with preview functionality
 *
 * @example
 * // Basic usage
 * <Image src="path/to/image.jpg" />
 *
 * // With rounded corners
 * <Image src="path/to/image.jpg" rounded="large" />
 *
 * // With custom class and custom rounding
 * <Image src="path/to/image.jpg" rounded="18px" className="custom-image" />
 */
const Image = ( props ) => {
    const { className, src, rounded, alt, ...restProps } = props;
    const [ visible, setVisible ] = useState( false );
    const handleCancel = () => {
        setVisible( false );
    };
    const showModal = () => {
        setVisible( true );
    };
    let size;
    if ( rounded && typeof rounded === 'string' ) {
        switch ( rounded ) {
            case 'large':
                size = '14px';
                break;
            case 'medium':
                size = '10px';
                break;
            case 'small':
                size = '6px';
                break;
            default:
                size = rounded;
                break;
        }
    }
    const imageClasses = classNames( {
        [ className ]: className ? true : false,
        'image-container': true,
        'rounded': rounded ? true : false
    } );
    return (
        <div className={ imageClasses } style={ rounded ? { borderRadius: size, minWidth: restProps.width ? restProps.width : 'auto' } : undefined }>
            <Img
                src={ src }
                onClick={ showModal }
                preview={ !src ? false : {
                    visible: visible,
                    imageRender: () => ImageRender( { src, handleCancel } ),
                    toolbarRender: () => null,
                    mask: (
                        <MaskComponent />
                    ),

                } }
                fallback={ Transparent }
                style={ rounded ? { borderRadius: size, overflow: 'hidden' } : {} }
                { ...restProps }
                alt={ !src ? getString( 'origami.image.notFound' ) : alt ? alt : undefined }

            />
        </div> );
};
export { Image };
